module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/navigation/arrow-left-75401a8cfe69139427932d456fc2666b.svg";